import React from 'react'
import styled from 'styled-components'
import { Button, Colors, Modal, Display, Select } from 'advenio-components'
import { Form } from 'formsy-react-2'
import PropTypes from 'prop-types'

const WarningZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.yellow100};
  flex-direction: column;
  color:${Colors.yellowText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const WarningRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }

`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`
const Text = styled(Display)`
  color: ${Colors.gray700};
  margin-bottom: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
`

const ConfirmResservationBmx = ({ itemId, handleSubmit, isOpen, loading,loadingPayments, onClose, typeToDelete, modalTitle, typeModal, payments }) => (
  <Modal
    isOpened={isOpen}
    onClose={onClose}
    headerTitle={` ${typeModal === 'authorize' ? 'Autorización ': typeModal === 'pending'? 'Desautorización':typeModal === 'paid' ? 'Pagar ':'Cancelar '}${typeToDelete}`}
    loading={loadingPayments}
  >
    <Container>
      <Form onSubmit={({payment_id = null}) => handleSubmit(itemId, payment_id)} >
        <Text>¿Seguro que deseas {typeModal === 'authorize' ? 'autorizar ':typeModal === 'pending' ? 'desautorizar ':typeModal === 'paid' ? 'pasar a Pagado ':'cancelar '} esta {typeToDelete} de {modalTitle  !== undefined ? <b>{modalTitle.fullName}</b> : null }?</Text>
       {typeModal=== 'paid'&& payments.length > 0 &&(
        <Select
          label={"Selecciona un Pago"}
          name={"payment_id"}
          options={payments}
          required
        />
       )}
       {(typeModal === 'paid'||typeModal === 'cancel')&& (
          <WarningZone>
          <h3>Aviso</h3>
          <WarningRow>
            <div>
            {payments.length < 1 && typeModal === 'paid' && (<span>Asegurate de que el tutor tenga pagos en este mes y con tarjeta.</span>)}
            {typeModal === 'cancel' && (<span>Si se cancela no se podra reactivar esta reservación.</span>)}
            </div>
          </WarningRow>
        </WarningZone>
       )}
        <ButtonContainer>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            primary
            loading={loading}
            type="submit"
            disabled={typeModal=== 'paid' && payments.length < 1}
          >
            {typeModal === 'authorize' ? 'Autorizar ': typeModal === 'pending' ? 'Desautorizar ': typeModal === 'paid' ? 'Pagar ': 'Cancelar '}  {typeToDelete}
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  </Modal>
)

ConfirmResservationBmx.propTypes = {
  /** The student charge to be deleted */
  itemId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  /** Callback function to be fired when submitting the form */
  handleSubmit: PropTypes.func.isRequired,
  /** Indicates if the modal should be open or not */
  isOpen: PropTypes.bool,
  /** Indicates if the charge is in the process of being deleted */
  loading: PropTypes.bool.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Type of element to delete */
  typeToDelete: PropTypes.string.isRequired,
}

ConfirmResservationBmx.defaultProps = {
    itemId: 0,
  isOpen: false,
}

export default ConfirmResservationBmx



// WEBPACK FOOTER //
// ./src/Containers/ReservationBMX/ConfirmResservationBmx.jsx